import kitchenInstance from '../instance'

const getWaiterNotifications = (kitchenMonitorId) => {
	return kitchenInstance.get(`/waiterNotifications${kitchenMonitorId ? `?kitchenMonitorId=${kitchenMonitorId}` : ''}`)
}

export default getWaiterNotifications
